import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import * as UI from 'ui'
import { ButtonWrap, Card } from 'ui'
import { Collection, ExecuteOperationOnPipe, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { PaginationFilter } from '@morningtrain/react-filters'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Link, NavigateOnPipe } from '@morningtrain/react-navigation'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import * as Icons from 'ui/icons'
import BackToOverview from 'widgets/navigation/BackToOverview'

export default function Templates () {
  return (
    <AdminPage>
      <Translator namespace='cleaning'>
        <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
          <UI.PageHeader title={<TranslatedTitle name='titles.templates' />}>
            <UI.ButtonWrap>
              <BackToOverview route='app.cleaning.summary'>
                <Translation name='actions.back_to_overview' />
              </BackToOverview>
              <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
                <Link route='app.cleaning.edit_template'>
                  <UI.Button>
                    <Translation name='actions.create_template' />
                  </UI.Button>
                </Link>
              </Can>
            </UI.ButtonWrap>
          </UI.PageHeader>
          <Collection resourceName='cleaning.category'>
            <UI.TableHeader>
              <Translator name='onboarding.filters' />
            </UI.TableHeader>

            <WhenCollectionIsNotEmpty>
              <Card>
                <Translator namespace='cleaning.templates'>
                  <Table>
                    <Columns.Text name='name' />
                    <Columns.Column>
                      <ButtonWrap className='my-0'>
                        <Pipeline>
                          <TriggerPipelineOnClick>
                            <UI.SquareButton color='btn-primary' className='p-2'>
                              <Icons.Pencil />
                            </UI.SquareButton>
                          </TriggerPipelineOnClick>
                          <NavigateOnPipe
                            route='app.cleaning.edit_template'
                            routeParameters={{ cleaning_checkup_category: 'model:id' }}
                          />
                        </Pipeline>
                        <DeleteModelOnClick pipes={<ExecuteOperationOnPipe operationName='index' />}>
                          <UI.DeleteButton />
                        </DeleteModelOnClick>
                      </ButtonWrap>
                    </Columns.Column>
                  </Table>
                  <PaginationFilter />
                </Translator>
              </Card>
            </WhenCollectionIsNotEmpty>
          </Collection>
        </Can>
      </Translator>
    </AdminPage>
  )
}
